import { PermissionValues, useCurrentAccount } from '@gripp/shared-logic';
import {
  Colors,
  RoutineExecutionProps,
  RoutineModal,
  Spacing,
} from '@gripp/shared-ui';
import { SetStateAction, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Button } from 'react-native-paper';
import { useNavigate } from 'react-router-dom';
import { CopyToWorkspaceButton } from '../../new-routines/components/copyToWorkspaceButton';
import { DeleteRoutineButton } from '../../new-routines/components/deleteRoutineButton';

type routinePreviewModal = {
  executeModalProps: RoutineExecutionProps;
  openRoutinePreviewModal: boolean;
  setOpenRoutinePreviewModal: (value: SetStateAction<boolean>) => void;
  setExecuteModalProps: (
    value: SetStateAction<RoutineExecutionProps | undefined>
  ) => void;
};
export const RoutinePreviewModal = ({
  executeModalProps,
  openRoutinePreviewModal,
  setOpenRoutinePreviewModal,
  setExecuteModalProps,
}: routinePreviewModal) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { account } = useCurrentAccount();

  const isGlobalAdmin = useMemo(
    () => !!(account && account.hasPermission(PermissionValues.globalAdmin)),
    [account]
  );

  const rightFormButton = executeModalProps?.routine && isGlobalAdmin && (
    <Button
      style={styles.button}
      labelStyle={styles.buttonLabel}
      onPress={() => {
        navigate(`/new-routines/${executeModalProps?.routine?.id}/edit`);
      }}
      buttonColor={Colors.primary}
    >
      {t('topNav.modify')}
    </Button>
  );

  const footer = executeModalProps?.routine && isGlobalAdmin && (
    <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
      <DeleteRoutineButton
        onSelected={() => setOpenRoutinePreviewModal(false)}
        workspaceRoutine={executeModalProps.routine}
      />
      <CopyToWorkspaceButton
        onSelected={() => setOpenRoutinePreviewModal(false)}
        workspaceRoutine={executeModalProps.routine}
      />
    </View>
  );

  return (
    <RoutineModal
      {...executeModalProps}
      visible={openRoutinePreviewModal}
      onCanceled={() => {
        setOpenRoutinePreviewModal(false);
        setExecuteModalProps(undefined);
      }}
      onCompleted={async () => {
        setOpenRoutinePreviewModal(false);
      }}
      rightFormButton={rightFormButton}
      footer={footer}
      showPortal
    />
  );
};

const styles = StyleSheet.create({
  button: {
    borderRadius: 8,
    width: '100%',
    maxWidth: 100,
    height: 44,
    justifyContent: 'center',
    marginRight: Spacing.baseMargin.base,
  },
  buttonLabel: {
    fontSize: 16,
    fontWeight: '500',
    color: Colors.white,
  },
});
